// Off Canvas logic
document.addEventListener( 'DOMContentLoaded', () => {
	const body = document.body;
	const toggleButton = document.querySelectorAll( '.offcanvas-toggler' );

	toggleButton.forEach( ( button ) => {
		const offCanvas = document.querySelector( '[data-toggler="' + button.dataset.toggle + '"]' );

		// Remove inline display: none to prevent offcanvas showing up on page load
		offCanvas.removeAttribute( 'style' );

		button.addEventListener( 'click', () => {
			offCanvas.classList.toggle( 'closed' );
			offCanvas.classList.toggle( 'opened' );
			button.classList.toggle( 'toggle-open' );
			body.classList.toggle( 'offcanvas-open' );
		} );
	} );
} );
